import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  ViewChild,
  ComponentFactoryResolver,
  ViewContainerRef,
  Output,
  EventEmitter,
} from '@angular/core';

import { LhStorageService } from '@hssa-itasia/ngx-util-core';
import { debounceTime, distinctUntilChanged, Subject, Subscription, takeUntil } from 'rxjs';
import { TabComponent } from './relates-tab.component';
import { AppService } from '../app.service';

@Component({
  selector: 'relates-to-tabs',
  template: `
    <div class="tab_main_div">
      <div *ngFor="let tab of tabs" (click)="selectTab(tab)">
        <div *ngIf="!tab.active" class="relates_to_topic">
          <img [src]="tab.inactive_icon" />
        </div>
        <div *ngIf="tab.active" class="relates_to_topic_active">
          <img [src]="tab.active_icon" />
          <div class="activeTAB">{{ tab.title }}</div>
        </div>
      </div>
    </div>
    <ng-content></ng-content>
  `,
  styles: [
    `
      .activeTAB {
        text-align: left;
        font-size: 14px;
        letter-spacing: 0.12px;
        color: #ffffff;
        opacity: 1;
        margin-left: 10px;
        white-space: nowrap;
      }
      .relates_to_topic_active {
        padding: 0 30px;
        margin-right: 10px;
        height: 45px;
        background: #007382;
        box-shadow: 0px 0px 18px #00000045;
        border-radius: 30px;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .relates_to_topic {
        width: 45px;
        height: 45px;
        background: #d6eaeb;
        opacity: 1;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
      }
      .highLightCss {
        color: red;
        font-size: 20px;
      }
      .tab_main_div {
        display: flex;
        align-items: center;
        justify-content: left;
        flex-wrap: nowrap;
        overflow-x: auto;
        height: 70px;
      }
    `,
  ],
  standalone: false,
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
  @Output() relatesToTab = new EventEmitter<any>();
  subscriber: Subscription;
  private destroy$ = new Subject<void>();
  constructor(
    private lhStorage: LhStorageService,
    private appService: AppService
  ) {}

  ngAfterContentInit() {
    console.log('inside relatesTo tab group', this.tabs);
    let activeTabs = this.tabs.filter((tab) => tab.active);
    this.tabs.toArray().forEach((ele: any) => {
      if (ele.title == 'Health') {
        (ele.active_icon = 'assets/img/rapid-tour/WeTalk/active_health.svg'),
          (ele.inactive_icon = 'assets/img/rapid-tour/WeTalk/inactive_health.svg');
      }
      if (ele.title == 'Safety') {
        (ele.active_icon = 'assets/img/rapid-tour/WeTalk/active_safety.svg'),
          (ele.inactive_icon = 'assets/img/rapid-tour/WeTalk/inactive_safety.svg');
      }
      if (ele.title == 'Environment') {
        (ele.active_icon = 'assets/img/rapid-tour/WeTalk/active_env.svg'),
          (ele.inactive_icon = 'assets/img/rapid-tour/WeTalk/inactive_env.svg');
      }
      if (ele.title == 'CC') {
        (ele.active_icon = 'assets/img/rapid-tour/WeTalk/active_houskeeping.svg'),
          (ele.inactive_icon = 'assets/img/rapid-tour/WeTalk/inactive_houskeeping.svg');
      }
      if (ele.title == 'Facilities') {
        (ele.active_icon = 'assets/img/house-keeping/facility_filled_bog_tour.svg'),
          (ele.inactive_icon = 'assets/img/rapid-tour/facility_thick_border_bog_tour.svg');
      }
      if (ele.title == 'Industrial areas') {
        (ele.active_icon = 'assets/img/house-keeping/industrial_filled.svg'),
          (ele.inactive_icon = 'assets/img/rapid-tour/industrial_thick_border.svg');
      }
    });
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }
    if (
      this.appService.appData.userInfo.h_and_s == 'YES' ||
      this.appService.appData.userInfo.profile.toLowerCase() == 'country exco'
    ) {
      this.checkUpdateData(activeTabs);
    }

    this.appService.selectedISEETabsRelatesTo
      .pipe(
        debounceTime(100), // Wait for rapid emissions to settle
        distinctUntilChanged(), // Ignore duplicates
        takeUntil(this.destroy$) // Clean up
      )
      .subscribe(async (res) => {
        console.log('res=', res);
        let editObservation = await this.lhStorage.get('editObservation');
        if (editObservation) this.handleTabSelection(res);
      });
  }
  handleTabSelection(res) {
    this.tabs.toArray().forEach((ele: any) => {
      if (ele.title == res) {
        ele.active = true;
        this.selectTab(ele);
      } else {
        ele.active = false;
      }
    });
  }
  async checkUpdateData(activeTabs) {
    let editObservation = await this.lhStorage.get('editObservation');
    if (editObservation != null || editObservation != undefined) {
      let relatesTo: any = editObservation.currentObservationInfo.selectedRelatesTo;
      if (editObservation.currentObservationInfo.type != 'CVPC') {
        this.tabs.forEach((element) => {
          relatesTo.forEach((relates) => {
            if (element.title.toLowerCase() == relates.haz_category.toLowerCase()) {
              element.active = true;
              this.selectTab(element);
            }
          });
        });
      }
    }
  }

  selectTab(tab: any) {
    this.tabs.toArray().forEach((tab) => (tab.active = false));
    tab.active = true;

    // this.formControl.patchValue(obj);
    // this.formControl.markAsTouched();
    this.relatesToTab.emit(tab);
  }
  ngOnDestroy() {
    console.log('ondestroy called');
    this.destroy$.next();
    this.destroy$.complete();
  }
}
